export enum Features {
  Unknown = "Unknown",
  PortalAssignee = "PortalAssignee",
  ReadDataFromSASS = "ReadDataFromSASS",
  SignatureDetectionIntelligence = "SignatureDetectionIntelligence",
  AutomateDigitizationOfHanddrawnSignature = "AutomateDigitizationOfHanddrawnSignature",
  VirtualMeeting = "VirtualMeeting"
}
